import { StepType } from '@reactour/tour';
import { TutorialContentBox } from './TutorialContentBox';

export const tutorialOneSteps: Array<StepType> = [
  {
    selector: '[data-tour="tile-4"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Kachel hinzufügen', EN: `Add tile` }}
        text={{
          DE: 'Klicken sie auf eine für die Kachel vorgesehenen Platz mit “+”.',
          EN: `Click on a space provided for the tile with “+”.`
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="side-tile-3"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Kachel hinzufügen', EN: `Add tile` }}
        text={{
          DE:
            'Wählen Sie eine Kachel aus der Liste der vorgegebenen Themen aus und klicken Sie auf  “+”.',
          EN: `Select a tile from the list of predefined themes and click “+”.`
        }}
      />
    ),
    position: 'right'
  },
  {
    selector: '[data-tour="tile-4"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Kachel hinzufügen', EN: `Add tile` }}
        text={{
          DE:
            'Die gewünscht Kachel erscheint auf dem ausgewählten Platz. Diese können Sie nun per Drag and Drop auf eine andere vorgesehene Stelle platzieren oder mit dem “Stift Symbol” (oben rechts) die aktuelle Kacheln mit einer anderen aus der Liste wechseln.',
          EN: `The desired tile appears in the selected slot. You can now use drag and drop to move this to another designated location or use the “pen symbol” (top right) to switch the current tile to another from the list.`
        }}
      />
    ),
    position: 'right'
  }
];

export const tutorialTwoSteps: Array<StepType> = [
  {
    selector: '[data-tour="tile-3"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Logo Ändern', EN: `Change Logo` }}
        text={{
          DE:
            'Klicken sie auf die Kachel mit dem Logo, um ein anderes Bild über die Upload Funktion Ihres Browsers hoch zu laden.',
          EN: `Click on the tile with the logo to upload another image using your browser's upload function.`
        }}
      />
    ),
    position: 'right'
  },
  {
    selector: '[data-tour="tile-3"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Logo Ändern', EN: `Change Logo` }}
        text={{
          DE:
            'Das gewünschte Logo erscheint auf der dafür vorgesehenen Stelle.',
          EN: `The desired logo appears in the space provided.`
        }}
      />
    ),
    position: 'right'
  },
  {
    selector: '[data-tour="menu"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'THeme Ändern', EN: `Change theme` }}
        text={{
          DE: 'Klicken Sie auf das “Pinsel Symbol”, um das Menü zu öffnen.',
          EN: `Click on the “Brush Icon” to open the menu.`
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="header-0"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'THeme Ändern', EN: `Change theme` }}
        text={{
          DE: 'Wählen Sie eine der verfügbaren Themes aus.',
          EN: `Choose one of the available themes.`
        }}
      />
    ),
    position: 'left'
  }
];

export const tutorialThreeSteps: Array<StepType> = [
  {
    selector: '[data-tour="main-grid"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Speichern', EN: `Save configuration` }}
        text={{
          DE:
            'Sie haben Ihr [ui!] COCKPIT erstellt und möchten die Konfiguration für spätere Zwecke speichern oder weitergeben.',
          EN: `You have created your [ui!] COCKPIT and would like to save or pass on the configuration for later use.`
        }}
      />
    ),
    position: 'left'
  },

  {
    selector: '[data-tour="menu-1"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Speichern', EN: `Save configuration` }}
        text={{
          DE:
            'Klicken sie hier auf das Menü-Icon mit den 3 Punkten, um sich die verfügbaren Optionen anzeigen zu lassen.',
          EN: `Here, click on the menu icon with the 3 dots to display the available options.`
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="menu-export"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Speichern', EN: `Save configuration` }}
        text={{
          DE:
            'In der Liste stehen ihnen wichtige Informationen und Funktionen zur Verfügung. Klicken sie auf “Exportiere Konfiguration (JSON)” und der Browser lädt die Konfigurationsdatei auf ihren PC herunter.',
          EN: `Important information and functions are available in the list. Click on “Export configuration (JSON)” and the browser will download the configuration file to your PC.
          `
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="menu-reset"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Zurücksetzen', EN: `Reset configuration` }}
        text={{
          DE:
            'Sie möchten die aktuelle Konfiguration der Kacheln löschen? Hierzu klicken sie auf “Zurücksetzen” und platzierten Kacheln werden gelöscht.',
          EN: `Would you like to delete the current configuration of the tiles? To do this, click on “Reset” and placed tiles will be deleted.`
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="menu-import"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Importieren', EN: `Import configuration` }}
        text={{
          DE:
            'Um eine bestehende Konfiguration hochzuladen, klicke sie auf “Importiere Konfiguration (JSON)” und laden sie über die Upload Funktion des Broswers, die Datei mit dem Namen “cockpit-configurator.json” hoch.',
          EN: `To upload an existing configuration, click on "Import configuration (JSON)" and use the browser's upload function to upload the file named "cockpit-configurator.json".`
        }}
      />
    ),
    position: 'left'
  },
  {
    selector: '[data-tour="main-grid"]',
    content: (
      <TutorialContentBox
        title={{ DE: 'Konfiguration Importieren', EN: `Import configuration` }}
        text={{
          DE:
            'Glückwunsch! Sie haben ihre gespeicherte Konfiguration importiert und die von ihnen konfigurierte Oberfläche erscheint nun auf dem [ui!] COCKPIT.',
          EN: `Congratulations! You have imported your saved configuration and the interface you configured now appears on the [ui!] COCKPIT.`
        }}
      />
    ),
    position: 'left'
  }
];
